// extracted by mini-css-extract-plugin
module.exports = {"panel":"_7910216"};